import { isNil } from 'lodash'

import { Input } from '@eastcoal/formily/components/Input'
import { InputProps } from '@eastcoal/formily/components/Input/interface'

const regexp = /^[a-zA-Z_]+$/

export const CodeInput = ({ onChange, ...restProps }: InputProps) => {
  return (
    <Input
      {...restProps}
      onChange={value => {
        if (isNil(value) || value === '') {
          onChange?.(value)
        } else if (regexp.test(`${value}`)) {
          onChange?.(`${value}`.toUpperCase())
        }
      }}
    />
  )
}
